<template>
  <el-form
    v-loading="loading"
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="140px"
    class="demo-ruleForm scroll_y"
    size="large"
    status-icon
  >
    <el-form-item label="选择院校" prop="schoolName">
      <PbschoolTable
        @change-school="changeSchool"
        :school-id="ruleForm.schoolId"
        :isEdit="isEdit"
      ></PbschoolTable>
      <span class="red">*添加之后不能修改</span>
    </el-form-item>
    <el-form-item label="院校所属专业" prop="majorId">
      <MajorTable
        @change-major="changeMajor"
        :majorId="ruleForm.majorId"
        :isEdit="isEdit"
      >
      </MajorTable>
      <span class="red">*添加之后不能修改</span>
    </el-form-item>
    <el-row>
      <el-col :span="12">
        <el-form-item label="原计划招生人数" prop="initialEnrolment">
          <el-row :span="24">
            <el-col :span="22">
              <el-tooltip
                class="item"
                effect="dark"
                content="只能输入数字（整数）且必须大于0"
                placement="top"
              >
                <el-input
                  type="number"
                  v-model.number="ruleForm.initialEnrolment"
                  placeholder="大于0的整数"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="1"><span class="form_unit">人</span></el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="调整后招生人数" prop="adjustEnrolment">
          <el-row :span="24">
            <el-col :span="22"
              ><el-tooltip
                class="item"
                effect="dark"
                content="只能输入数字（整数）且必须大于0"
                placement="top"
              >
                <el-input
                  type="number"
                  v-model.number="ruleForm.adjustEnrolment"
                  placeholder="大于0的整数"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="1"><span class="form_unit">人</span></el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="建档立卡考生人数" prop="inputtingCard">
          <el-row :span="24">
            <el-col :span="22">
              <el-tooltip
                class="item"
                effect="dark"
                content="只能输入数字（整数），可以是0"
                placement="top"
              >
                <el-input
                  type="number"
                  v-model.number="ruleForm.inputtingCard"
                  placeholder="可以是0"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="1"><span class="form_unit">人</span></el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="录取分数" prop="score">
          <el-row :span="24">
            <el-col :span="22">
              <el-input
                type="number"
                v-model.number="ruleForm.score"
                placeholder="请填写录取分数"
              />
            </el-col>
            <el-col :span="1">
              <span class="form_unit">分</span>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="考试科目" prop="majorCourses">
      <el-input
        v-model="ruleForm.majorCourses"
        :autosize="{ minRows: 2, maxRows: 4 }"
        type="textarea"
        placeholder="请填写考试科目"
        style=""
      />
    </el-form-item>
    <el-form-item label="考试教材" prop="majorSubject">
      <WangEditor
      :isDecode="false"
        v-if="editorShow"
        ref="setmajorSubject"
        :content="majorSubjectContent"
        @changeContent="setmajorSubject"
      ></WangEditor>
    </el-form-item>
    <el-form-item label="专科对照表" prop="comparisonTable">
      <WangEditor
      :isDecode="false"
        v-if="editorShow"
        ref="comparisonTable"
        :content="comparisonTableContent"
        @changeContent="setcomparisonTable"
      ></WangEditor>
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitForm(ruleFormRef)"
      >提交</el-button
    >
  </div>
</template>

<script>
import {
  findById,
  addSchoolMajor,
  editSchoolMajor,
} from "network/pbMajorSchool.js";
import WangEditor from "components/wangEditor/WangEditor.vue";
import PbschoolTable from "./PbschoolTable.vue";
import MajorTable from "./MajorTable.vue";
import { toRefs, reactive, ref, toRaw, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  name: "AddEditpbMajorSchool",
  components: {
    WangEditor,
    PbschoolTable,
    MajorTable,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
    isEdit: Boolean,
    typesList: Array,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      loading: false,
      editorShow: false, //用于获取到编辑详情 回显富文本
      ruleForm: {
        year: null,
        majorId: null,
        schoolId: null,
        schoolName: "",
        initialEnrolment: null,
        adjustEnrolment: null,
        majorCourses: "",
        majorSubject: "",
        comparisonTable: "",
        score: "",
        inputtingCard: 0,
      },
      rules: {
        schoolName: [
          { required: true, message: "请选择院校", trigger: "blur" },
        ],
        majorId: [
          {
            required: true,
            message: "请选择院校所属专业",
            trigger: "change",
          },
        ],
        initialEnrolment: [
          {
            required: true,
            message: "请填写原计划招生人数",
            trigger: "blur",
          },
        ],
        adjustEnrolment: [
          {
            required: true,
            message: "调整后招生人数",
            trigger: "blur",
          },
        ],
      },
      placeholder1: "请在这里输入考试教材",
      placeholder2: "请在这里输入专科对照表",
      majorSubjectContent: "",
      comparisonTableContent: "",
    });
    onMounted(() => {});

    // 父组件传得props
    const propsData = toRaw(props);
    //编辑请求专业院校详情
    if (propsData.editId > 0) {
      data.loading = true;
      findById(propsData.editId)
        .then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            data.editorShow = true;
            data.ruleForm = result.result;
            data.majorSubjectContent = data.ruleForm.majorSubject;
            data.comparisonTableContent = data.ruleForm.comparisonTable;
            // // 重新赋值描述说明，避免无法重新编辑
            // data.newcontents = result.result.contents;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      data.editorShow = true;
    }
    //获取选择院校组件传递过来的值
    const changeSchool = (val) => {
      if (toRaw(val)) {
        data.ruleForm.schoolId = toRaw(val).id;
        data.ruleForm.schoolName = toRaw(val).name;
        ruleFormRef.value.clearValidate("schoolName"); //移除校验结果
      } else {
        data.ruleForm.schoolId = null;
        data.ruleForm.schoolName = "";
      }
    };
    //获取选择专业组件传递过来的值
    const changeMajor = (val) => {
      if (toRaw(val)) {
        data.ruleForm.majorId = toRaw(val).id;
        data.ruleForm.year = toRaw(val).year;
        ruleFormRef.value.clearValidate("majorId"); //移除校验结果
      } else {
        data.ruleForm.majorId = null;
        data.ruleForm.year = null;
      }
    };
    //获取富文本编辑器传过来的 考试教材
    const setmajorSubject = (val) => {
      if (val) {
        data.ruleForm.majorSubject = val;
        // data.ruleForm.majorSubject = encodeURIComponent(val);
        ruleFormRef.value.clearValidate("majorSubject"); //移除校验结果
      }
    };
    //获取富文本编辑器传过来的 专科对照表
    const setcomparisonTable = (val) => {
      if (val) {
        data.ruleForm.comparisonTable = val;
        // data.ruleForm.comparisonTable = encodeURIComponent(val);
        ruleFormRef.value.clearValidate("comparisonTable"); //移除校验结果
      }
    };
    // 提交
    const submitForm = async () => {
      // data.ruleForm.contents = data.newcontents;
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          const obj = toRaw(data.ruleForm);
          obj.score = String(obj.score);
          updataAdd(obj);
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd(data) {
      data.loading = true;
      let result = "";
      if (propsData.editId > 0) {
        data.id = propsData.editId;
        result = await editSchoolMajor(data);
      } else {
        result = await addSchoolMajor(data);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                });
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
           });
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      changeSchool,
      changeMajor,
      setmajorSubject,
      setcomparisonTable,
      submitForm,
      resetForm,
    };
  },
  methods: {
    searchData() {},
  },
};
</script>
<style scoped>
.red {
  margin-left: 20px;
  color: #f56c6c;
}
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 540px;
}
.form_unit {
  margin-left: 10px !important;
}
</style>

